import { _ as __rest } from './_tslib.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { generateClasses, isElementBottomAboveReferenceBottom, placeOver } from '@ids/tools';
import { I as IdsIcon } from './icon.js';
import { s as styleInject } from './style-inject.es.js';

var css_248z = ".ids-animation-fade-in-start {\n  opacity: 0;\n}\n\n.ids-animation-fade-in-moderate-end {\n  opacity: 1;\n  -webkit-transition: opacity 200ms cubic-bezier(0.42, 0, 0.58, 1);\n  transition: opacity 200ms cubic-bezier(0.42, 0, 0.58, 1);\n}\n\n.ids-animation-fade-out-start {\n  opacity: 1;\n}\n\n.ids-animation-fade-out-moderate-output-end {\n  opacity: 0;\n  -webkit-transition: opacity 275ms cubic-bezier(0.42, 0, 0.58, 1);\n  transition: opacity 275ms cubic-bezier(0.42, 0, 0.58, 1);\n}\n\n.ids-animation-scale-x-down {\n  -webkit-transform: scaleX(var(--ids-scale-x-down, 0));\n          transform: scaleX(var(--ids-scale-x-down, 0));\n}\n\n.ids-animation-scale-x-up {\n  -webkit-transform: scaleX(var(--ids-scale-x-up, 100%));\n          transform: scaleX(var(--ids-scale-x-up, 100%));\n}\n\n.ids-animation-time-transform-slow {\n  -webkit-transition: -webkit-transform 2000ms cubic-bezier(0, 0, 0.58, 1);\n  transition: -webkit-transform 2000ms cubic-bezier(0, 0, 0.58, 1);\n  transition: transform 2000ms cubic-bezier(0, 0, 0.58, 1);\n  transition: transform 2000ms cubic-bezier(0, 0, 0.58, 1), -webkit-transform 2000ms cubic-bezier(0, 0, 0.58, 1);\n}\n\n.ids-animation-width-down {\n  width: var(--ids-width-down, 0);\n}\n\n.ids-animation-width-up {\n  width: var(--ids-width-up, 100%);\n}\n\n.ids-animation-time-width-slow {\n  /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */\n  -webkit-transition: width 2000ms cubic-bezier(0, 0, 0.58, 1);\n  transition: width 2000ms cubic-bezier(0, 0, 0.58, 1);\n}\n\n.ids-mobile-header,\n:host.ids-mobile-header {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: var(--ids_color_bg_base);\n  border-bottom: var(--ids_size_border_small) solid transparent;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  left: 0;\n  min-height: var(--ids_size_general_72x);\n  padding: 0 var(--ids_spacing_2x);\n  position: sticky;\n  top: 0;\n  -webkit-transition: background-color 200ms cubic-bezier(0.42, 0, 1, 1), color 200ms cubic-bezier(0.42, 0, 1, 1);\n  transition: background-color 200ms cubic-bezier(0.42, 0, 1, 1), color 200ms cubic-bezier(0.42, 0, 1, 1);\n  width: 100%;\n  /* stylelint-disable-next-line selector-pseudo-element-no-unknown */\n  /* stylelint-disable-next-line selector-pseudo-element-no-unknown */\n  /* stylelint-disable-next-line selector-pseudo-element-no-unknown */\n}\n.ids-mobile-header button,\n.ids-mobile-header .ids-icon,\n:host.ids-mobile-header button,\n:host.ids-mobile-header .ids-icon {\n  color: inherit;\n}\n.ids-mobile-header ::ng-deep ids-icon,\n:host.ids-mobile-header ::ng-deep ids-icon {\n  color: inherit;\n}\n.ids-mobile-header__presentation,\n:host.ids-mobile-header__presentation {\n  opacity: 0;\n  overflow: hidden;\n  pointer-events: initial;\n}\n.ids-mobile-header__controls,\n:host.ids-mobile-header__controls {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: auto;\n}\n.ids-mobile-header ::ng-deep .ids-mobile-header__controls,\n:host.ids-mobile-header ::ng-deep .ids-mobile-header__controls {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: auto;\n}\n.ids-mobile-header__button,\n:host.ids-mobile-header__button {\n  background-color: transparent;\n  border: none;\n  height: var(--ids_size_general_48x);\n  line-height: 1;\n  width: var(--ids_size_general_48x);\n}\n.ids-mobile-header ::ng-deep .ids-mobile-header__button,\n:host.ids-mobile-header ::ng-deep .ids-mobile-header__button {\n  background-color: transparent;\n  border: none;\n  height: var(--ids_size_general_48x);\n  line-height: 1;\n  width: var(--ids_size_general_48x);\n}\n.ids-mobile-header--collapsed,\n:host.ids-mobile-header--collapsed {\n  border-color: var(--ids_color_border_soft);\n  -webkit-transition: background-color 250ms cubic-bezier(0.42, 0, 1, 1), color 250ms cubic-bezier(0.42, 0, 1, 1);\n  transition: background-color 250ms cubic-bezier(0.42, 0, 1, 1), color 250ms cubic-bezier(0.42, 0, 1, 1);\n  z-index: 1000;\n}\n.ids-mobile-header--collapsed .ids-mobile-header__presentation,\n:host.ids-mobile-header--collapsed .ids-mobile-header__presentation {\n  -webkit-box-flex: 1;\n      -ms-flex: auto;\n          flex: auto;\n  margin-left: var(--ids_spacing_4x);\n  opacity: 1;\n  pointer-events: initial;\n  -webkit-transition: opacity 250ms ease-in;\n  transition: opacity 250ms ease-in;\n}\n.ids-mobile-header--collapsed .ids-mobile-header__presentation > *,\n:host.ids-mobile-header--collapsed .ids-mobile-header__presentation > * {\n  font: var(--ids_textStyle_f02_s16_h24_wrg);\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ids-mobile-header--collapsed .ids-mobile-header__button + .ids-mobile-header__presentation,\n:host.ids-mobile-header--collapsed .ids-mobile-header__button + .ids-mobile-header__presentation {\n  margin-left: var(--ids_spacing_2x);\n}\n.ids-mobile-header--on-brand,\n:host.ids-mobile-header--on-brand {\n  color: var(--ids_color_contrast_onBrand_primary);\n  /* stylelint-disable selector-pseudo-element-no-unknown */\n  /* stylelint-disable-next-line no-descending-specificity */\n}\n.ids-mobile-header--on-brand ::ng-deep .ids-mobile-header__button,\n:host.ids-mobile-header--on-brand ::ng-deep .ids-mobile-header__button {\n  color: var(--ids_color_contrast_onBrand_primary);\n}\n.ids-mobile-header--on-brand.ids-mobile-header--collapsed,\n:host.ids-mobile-header--on-brand.ids-mobile-header--collapsed {\n  border-color: var(--ids_color_action_primary_contrast_soft);\n}\n\n.ids-mobile-header-wrapper {\n  display: block;\n  position: sticky;\n  top: 0;\n}\n\n.voxel-theme-empresas .ids-mobile-header:not(.ids-mobile-header--on-brand) {\n  background: var(--ids_color_bg_brand_gradient);\n  color: var(--ids_color_contrast_onBrand_primary);\n}";
styleInject(css_248z);

/**
 * Este hook faz bind de um evento em um determinado elemento HTML e também desfaz
 * quando o componente é destruído.
 *
 * @param el Elemento HTML que será escutado os eventos.
 * @param type Tipo de vento a ser escutado. Exemplo "click" | "scroll"...
 * @param handle Função de callback.
 */
const useBindEvent = (externalEl, type, handle) => {
  useEffect(() => {
    const el = (externalEl === null || externalEl === void 0 ? void 0 : externalEl.current) || externalEl;
    if (el) {
      el.removeEventListener(type, handle);
      el.addEventListener(type, handle);
    }
    return () => {
      if (el) {
        el.removeEventListener(type, handle);
      }
    };
  }, [externalEl, handle, type]);
};

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsMobileHeader } from '@ids/react';
 * ```
 */
const IdsMobileHeader = _a => {
  var {
      contrast,
      children,
      controls = [],
      onBack,
      backLabel = 'voltar',
      backProps,
      headingRef,
      scrollingRef,
      sticky,
      className = '',
      style,
      bgColor,
      collapsedBgColor,
      collapsedContrast
    } = _a,
    props = __rest(_a, ["contrast", "children", "controls", "onBack", "backLabel", "backProps", "headingRef", "scrollingRef", "sticky", "className", "style", "bgColor", "collapsedBgColor", "collapsedContrast"]);
  const [isReady, setIsReady] = useState(false);
  const ref = useRef();
  const presentationtRef = useRef(null);
  const [collapsed, setCollapsed] = useState(Boolean(children));
  const currentBgColor = collapsed ? collapsedBgColor : bgColor;
  const classes = useMemo(() => {
    const scrollingEl = scrollingRef === null || scrollingRef === void 0 ? void 0 : scrollingRef.current;
    const currentContrast = collapsed ? collapsedContrast : contrast;
    const isInsideScroll = Boolean(scrollingEl && ref && scrollingEl.contains(ref.current));
    return generateClasses({
      'ids-mobile-header': isReady,
      'ids-mobile-header--sticky': sticky || isInsideScroll,
      'ids-mobile-header--on-brand': currentContrast === 'onBrand',
      'ids-mobile-header--collapsed': collapsed,
      [className]: className
    });
  }, [scrollingRef, collapsed, collapsedContrast, contrast, isReady, sticky, className]);
  const handleScroll = useCallback(() => {
    const headingElement = headingRef === null || headingRef === void 0 ? void 0 : headingRef.current;
    if (!headingRef || !ref || !isReady) {
      return;
    }
    const outOfScroll = isElementBottomAboveReferenceBottom(headingElement, ref.current);
    if (!outOfScroll) {
      placeOver(presentationtRef.current, headingRef.current);
    }
    if (outOfScroll === collapsed) {
      return;
    }
    if (outOfScroll) {
      placeOver(presentationtRef.current);
    }
    setCollapsed(outOfScroll);
  }, [isReady, headingRef, collapsed]);
  const templateControls = useMemo(() => jsx(Fragment, {
    children: controls.map(_a => {
      var {
          icon,
          content,
          className: controlClassName = ''
        } = _a,
        controlProps = __rest(_a, ["icon", "content", "className"]);
      const controlClasses = generateClasses({
        'ids-mobile-header__button': true,
        [controlClassName]: controlClassName
      });
      return jsxs("button", Object.assign({
        className: controlClasses
      }, controlProps, {
        children: [content, icon && jsx(IdsIcon, Object.assign({
          size: "M"
        }, {
          children: icon
        }))]
      }), icon || String(content));
    })
  }), [controls]);
  const templateBackButton = useMemo(() => {
    const backButtonClasses = generateClasses({
      'ids-mobile-header__button': true,
      [(backProps === null || backProps === void 0 ? void 0 : backProps.className) || '']: backProps === null || backProps === void 0 ? void 0 : backProps.className
    });
    if (!onBack) {
      return null;
    }
    return jsx("button", Object.assign({
      onClick: onBack,
      "aria-label": backLabel
    }, backProps, {
      className: backButtonClasses
    }, {
      children: jsx(IdsIcon, Object.assign({
        size: "M"
      }, {
        children: (backProps === null || backProps === void 0 ? void 0 : backProps.children) || 'seta_esquerda'
      }))
    }));
  }, [backLabel, backProps, onBack]);
  const templateHeading = useMemo(() => {
    var _a;
    if (!children && isReady) {
      return jsx("div", {
        ref: presentationtRef,
        className: "ids-mobile-header__presentation",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: String((_a = headingRef === null || headingRef === void 0 ? void 0 : headingRef.current) === null || _a === void 0 ? void 0 : _a.outerHTML).replace(/ class=".*"/, '')
        }
      });
    }
    return jsx("div", Object.assign({
      className: "ids-mobile-header__presentation"
    }, {
      children: children
    }));
  }, [isReady, children, headingRef]);
  useBindEvent(window, 'resize', handleScroll);
  useBindEvent(window, 'load', handleScroll);
  useBindEvent(document, 'scroll', handleScroll);
  useEffect(() => {
    if (headingRef && isReady) {
      (headingRef === null || headingRef === void 0 ? void 0 : headingRef.current).setAttribute('aria-hidden', 'true');
    }
  }, [headingRef, isReady]);
  useEffect(() => {
    var _a, _b;
    if (!children && scrollingRef && isReady) {
      (_a = scrollingRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', handleScroll);
      (_b = scrollingRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('scroll', handleScroll);
    }
    return () => {
      var _a;
      if (!children && scrollingRef && isReady) {
        // TODO: verificar essa regra
        // eslint-disable-next-line react-hooks/exhaustive-deps
        (_a = scrollingRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', handleScroll);
      }
    };
  }, [children, handleScroll, scrollingRef, isReady]);
  useEffect(() => {
    setIsReady(true);
  }, [setIsReady]);
  return useMemo(() => jsxs("header", Object.assign({
    ref: ref,
    className: classes,
    style: Object.assign({
      backgroundColor: currentBgColor
    }, style)
  }, props, {
    children: [templateBackButton, templateHeading, jsx("div", Object.assign({
      className: "ids-mobile-header__controls"
    }, {
      children: templateControls
    }))]
  })), [currentBgColor, classes, props, style, templateBackButton, templateControls, templateHeading]);
};

export { IdsMobileHeader as I };
//# sourceMappingURL=mobile-header.js.map
